import { createFileRoute, notFound } from "@tanstack/react-router";
import { i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { getPreset } from "@/tools/timer/lib/presets";
import { PresetTimerPage } from "@/tools/timer/pages/PresetTimerPage";

export const Route = createFileRoute("/timer/$preset")({
  ssr: true,
  loader: ({ params }) => {
    if (!getPreset(params.preset)) throw notFound();
  },
  head: ({ params }) => {
    const preset = getPreset(params.preset);
    if (!preset) return {};
    return {
      meta: [
        { title: preset.metaTitle() },
        { name: "description", content: preset.metaDescription() },
        { property: "og:title", content: preset.metaTitle() },
        { property: "og:description", content: preset.metaDescription() },
        ...i18nOgMeta(preset.path),
      ],
      links: [...i18nLinks(preset.path)],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: m.timer_breadcrumb_home(),
                item: localeUrl(`/`),
              },
              {
                "@type": "ListItem",
                position: 2,
                name: m.timer_tool_name(),
                item: localeUrl(`/timer`),
              },
              {
                "@type": "ListItem",
                position: 3,
                name: preset.navName(),
                item: localeUrl(`${preset.path}`),
              },
            ],
          }),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: preset.faqs.map((f) => ({
              "@type": "Question",
              name: f.q(),
              acceptedAnswer: { "@type": "Answer", text: f.a() },
            })),
          }),
        },
      ],
    };
  },
  component: PresetRoute,
});

function PresetRoute() {
  const { preset } = Route.useParams();
  const def = getPreset(preset);
  // loader throws notFound for unknown slugs, so def is always defined here.
  if (!def) return null;
  return <PresetTimerPage preset={def} />;
}
